import { render, staticRenderFns } from "./BrandVehicleCreate.vue?vue&type=template&id=22f81976"
import script from "./BrandVehicleCreate.vue?vue&type=script&lang=js"
export * from "./BrandVehicleCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports